<template>
  <div class="mapLabelFormPanel">
    <div class="contentBox">
      <div class="mapLabelForm" v-if="selectedBlock || selectedIcon">
        <div class="formItem">
          <div class="formItem__title">POI名称</div>
          <el-input v-model="formData.poi_name"
                    style="width:100%"
                    placeholder="请输入POI名称"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">POI类型</div>
          <el-select v-model="formData.icon_id"
                     size="small"
                     style="width:100%"
                     placeholder="请选择POI类型"
                     clearable>
            <template v-for="(item, index) in iconList">
              <el-option
                v-if="!item.is_delete"
                :key="index"
                :label="item.description"
                :value="item.id">
              </el-option>
            </template>

          </el-select>
        </div>
        <div class="formItem" v-for="(item,index) in uploadsData" :key="index">
          <div class="formItem__title">{{item.name}}</div>
          <!-- .jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF -->
          <el-upload
            ref="upload"
            action="/function/deployment-service/icon/upload_img_file"
            :headers="{token:getToken()}"
            name="file"
            accept=".jpg,.jpeg,.png,JPG,.JPEG"
            :limit="item.limit"
            :auto-upload="true"
            :file-list="item.fileList"
            list-type="picture-card"
            :on-success="(res)=>{successUploadFunc(res,item.key)}"
            :on-remove="(file,fileList)=>{removeFormData(file,fileList,item.key)}"
            :on-exceed="onExceed">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <div class="formItem">
          <div class="formItem__title">缩放级别</div>
          <el-select v-model="formData.scale_level"
                     size="small"
                     style="width:100%"
                     placeholder="请选择缩放级别"
                     clearable>
            <el-option
              v-for="(item, index) in levels"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="formItem">
          <div class="formItem__title">推荐性别</div>
          <el-select v-model="formData.recommended_gender"
                     size="small"
                     style="width:100%"
                     placeholder="请选择推荐性别"
                     clearable>
            <el-option
              v-for="(item, index) in gender"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="formItem">
          <div class="formItem__title">推荐年龄</div>
          <el-input v-model="formData.recommended_age"
                    type="num"
                    style="width:100%"
                    placeholder="请输入推荐年龄"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">poi关联Id</div>
          <el-input v-model="formData.poi_number"
                    :maxlength="30"
                    show-word-limit
                    style="width:100%"
                    placeholder="请输入店铺号"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">联系电话</div>
          <el-input v-model="formData.phone"
                    style="width:100%"
                    placeholder="请输入联系电话"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">营业时间</div>
          <el-time-picker
            size="small"
            style="width:180px;"
            v-model="formData.business_hours[0]"
            placeholder="选择开始时间">
          </el-time-picker>
          至
          <el-time-picker
            size="small"
            style="width:180px;"
            :disabled="!formData.business_hours[0]"
            v-model="formData.business_hours[1]"
            placeholder="选择结束时间">
          </el-time-picker>
        </div>
        <div class="formItem">
          <div class="formItem__title">店铺描述</div>
          <el-input v-model="formData.description"
                    type="textarea"
                    style="width:100%"
                    placeholder="请输入店铺描述"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">大众点评链接</div>
          <el-input v-model="formData.link"
                    style="width:100%"
                    placeholder="请输入链接"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">区域分组</div>
          <el-input v-model="formData.area_group"
                    style="width:100%"
                    placeholder="请输入区域分组"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">客流系统ID</div>
          <el-input v-model="formData.ps_flow_sys_store_id"
                    style="width:100%"
                    placeholder="请输入客流系统ID"
                    size="small" />
        </div>
        <div class="formItem">
          <div class="formItem__title">备注</div>
          <el-input v-model="formData.remark"
                    style="width:100%"
                    placeholder="请输入备注"
                    size="small" />
        </div>
      </div>
      <div class="btnGroup" v-if="selectedBlock || selectedIcon">
        <el-button type="primary"
                   size="small"
                   @click="onSubmit">
          确 定
        </el-button>
        <el-button type="danger"
                   size="small"
                   @click="ondelete">
          删 除
        </el-button>
      </div>

      <material ref="material" :iconList="iconList" @queryAllIcon="$emit('queryAllIcon')"></material>
    </div>

  </div>
</template>

<script>
import { LayerManager, eventHub } from '@aibee/vincent';
import material from '@/components/mapComponents/material.vue';
import { createPoi, updatePoi, deletePoi, queryAllPois, uploadImage } from '@/api/map';
import { getToken } from '@/utils/auth';

export default {
  name: 'mapLabelFormPanel',
  components: { material },
  props: {
    selectedIcon: {
      type: Object,
      default: () => null,
    },
    selectedBlock: {
      type: Object,
      default: () => null,
    },
    iconList: {
      type: Array,
      default: () => null,
    },
  },
  watch: {
    selectedIcon(newVal, oldVal) {
      console.log(newVal);
      if (!newVal) {
        console.log(123);
        this.formData = {
          business_hours: [],
        };
        this.uploadsData.forEach((item) => {
          item.fileList = [];
        });
        return;
      }
      const iText = newVal.getObjects().find(item => item.type === 'i-text');
      const poiParams = JSON.parse(JSON.stringify(this.selectedIcon.poiParams));
      const config = JSON.parse(JSON.stringify(poiParams.config));
      delete poiParams.config;
      this.formData = {};
      // if (poiParams.business_hours.length <= 0) delete poiParams.business_hours;
      this.uploadsData.forEach((item) => {
        if (Array.isArray(poiParams[item.key])) {
          item.fileList = poiParams[item.key].map(url => ({ url }));
          this.formData[item.key] = poiParams[item.key];
        } else if (item.key === 'logo_url' && poiParams[item.key]) {
          item.fileList = [{ url: poiParams[item.key] }];
          this.formData[item.key] = [poiParams[item.key]];
        } else {
          item.fileList = [];
          this.formData[item.key] = [];
        }
      });
      this.formData = {
        icon_id: config.id,
        ...poiParams,
        ...this.formData,
        // scale_level: newVal.scaleLevel,
      };
    },
  },
  computed: {
    source() {
      return this.$route.params.source;
    },
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
  },
  data() {
    return {
      formData: {
        business_hours: [],
      },
      canvas: null,
      uploadsData: [
        {
          name: '店铺logo',
          key: 'logo_url',
          fileList: [],
          limit: 1,
        },
        {
          name: '店铺banner',
          key: 'poi_banner',
          fileList: [],
          limit: 2,
        },
        {
          name: '店铺特色图片',
          key: 'img_urls',
          fileList: [],
          limit: 2,
        },
      ],
      // fileList: [{ url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100' }],
      levels: [
        {
          id: 1,
          name: 'level1',
        },
        {
          id: 2,
          name: 'level2',
        },
        {
          id: 3,
          name: 'level3',
        },
      ],
      gender: [
        {
          id: 0,
          name: '男',
        },
        {
          id: 1,
          name: '女',
        },
        {
          id: 2,
          name: '男女均可',
        },
      ],
    };
  },
  created() {
  },
  beforeDestroy() {
  },
  mounted() {

  },
  methods: {
    getToken,
    onExceed(file, fileList) {
      this.$message.warning(`只能上传${fileList.length}张图片`);
    },
    successUploadFunc(res, keyName) {
      // if (keyName === 'logo_url' && res.data) {
      //   this.formData[keyName] = res.data;
      //   return;
      // }
      if (!Array.isArray(this.formData[keyName])) {
        this.formData[keyName] = [];
      }
      this.formData[keyName].push(res.data);
    },
    removeFormData(file, fileList, keyName) {
      const result = fileList.map(item => item.url);
      if (keyName === 'logo_url') {
        this.formData[keyName] = [];
      } else {
        this.formData[keyName] = result;
      }
    },
    onSubmit() {
      // const selectedBlockType = this.iconList.find(item => item.id === this.formData.blockTypeId);
      // console.log(selectedBlockType);
      if (!this.formData.poi_name) {
        this.$message.warning('请选择poi名称');
        return;
      }
      if (!this.formData.icon_id) {
        this.$message.warning('请选择poi类型');
        return;
      }
      if (this.formData.business_hours.length === 1 || this.formData.business_hours.findIndex(item => !item) > -1) {
        this.$message.warning('请同时填写开店和闭店时间');
        return;
      }
      const iconConfig = this.iconList.find(item => item.id === this.formData.icon_id);
      const poiParams = { ...this.formData };
      poiParams.config = iconConfig;
      if (this.selectedIcon) {
        const { poiParams: { config } } = this.selectedIcon;
        // this.selectedIcon.scaleLevel = this.formData.scale_level;
        const iText = this.selectedIcon.getObjects().find(item => item.type === 'i-text');
        if (config.id !== iconConfig.id) {
          LayerManager.getCurrentLayer().canvas.remove(this.selectedIcon);
          this.$emit('addSvgIcon', poiParams, { x: this.selectedIcon.left, y: this.selectedIcon.top }, this.formData.poi_name, 'update');
        } else {
          iText.set('text', this.formData.poi_name);
          poiParams.center_x = this.selectedIcon.left;
          poiParams.center_y = this.selectedIcon.top;
          // poiParams.set({ left: this.selectedIcon.left, top: this.selectedIcon.top });
          this.selectedIcon.poiParams = poiParams;
        }
        this.$emit('createAndUpdatePoi', this.selectedIcon, poiParams, 'update');
      } else if (this.selectedBlock && this.selectedBlock.type === 'CirclePoint') {
        // 标注点标注
        const center = this.selectedBlock.getCenterPoint();
        this.$emit('addSvgIcon', poiParams, { x: center.x, y: center.y }, this.formData.poi_name, 'create', true);
        LayerManager.getCurrentLayer().removeObject(this.selectedBlock);
      } else if (this.selectedBlock) {
        // 选中svgBlock标注
        poiParams.block_id = `${this.selectedBlock.id}`;
        const center = this.selectedBlock.getCenterPoint();
        this.$emit('addSvgIcon', poiParams, { x: center.x, y: center.y }, this.formData.poi_name, 'create', true);
      }

      LayerManager.getCurrentLayer().canvas.renderAll();
    },
    ondelete() {
      this.$emit('deletePoi', this.selectedIcon.poiParams.id);
      // this.$emit('deletePoi', 10);
    },

  },
};
</script>
<style lang="less" scoped>
    .mapLabelFormPanel{
    width: 290px;
    height: 100%;
    background-color: #1c1c1e;
    box-shadow: 1px 2px 2px 232323;
    z-index: 10;
    padding: 0px 30px 0 30px;
    box-sizing: border-box;
    overflow: auto;
    .contentBox{
      .mapLabelForm{
        background-color: #2c2c2e;
        padding: 20px 20px;
        border-radius: 20px 20px 0 0 ;
        height: 400px;
        overflow: auto;
        .formItem{
          margin-bottom: 20px;
          &__title{
            color: #bfc0c7;
            font-size: 12px;
            margin: 10px 0;
            font-weight: 700;
          }
          ::v-deep .el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 90px;
            background-color: #1c1c1e;
          }
          ::v-deep .el-upload-list__item{
            width: 80px;
            height: 80px;
          }
        }
      }
      .btnGroup{
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #2c2c2e;
        border-radius: 0 0 20px 20px;
        ::v-deep .el-button{
          width:43%;
          height: 32px;
        }
        ::v-deep .el-button+.el-button{
          margin-left: 20px;
        }
        ::v-deep .el-button:first-child{
          background-color: #6979ed;
          &:hover{
            background-color: #8693f0;
            transition: background 0.2s;
          }
        }
      }
    }

  }
</style>
